import { render, staticRenderFns } from "./RolesAccess.vue?vue&type=template&id=e0b826d0&"
import script from "./RolesAccess.vue?vue&type=script&lang=js&"
export * from "./RolesAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports